// extracted by mini-css-extract-plugin
module.exports = {"modal__container":"Modal_modal__container__2-F4n","modal":"Modal_modal__1vwov","modal__header":"Modal_modal__header__3Xa9z","close_btn":"Modal_close_btn__1W2UK"};